if (!customElements.get('video-plus-text')) {
  class VideoPlusText extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        playButton: '.video-plus-text__play-button',
        video: '.video-plus-text__video',
      };

      this.video = this.querySelector(this.selectors.video);
      this.playButton = this.querySelector(this.selectors.playButton);
    }

    connectedCallback() {
      this.playButton.addEventListener('click', this.onButtonClick.bind(this));
      this.video.addEventListener('pause', this.onVideoStop.bind(this));
    }

    disconnectedCallback() {
      this.playButton.removeEventListener('click', this.onButtonClick.bind(this));
      this.video.removeEventListener('pause', this.onVideoStop.bind(this));
    }

    onButtonClick() {
      this.video.play();
      this.video.controls = true;
      this.playButton.classList.add('video-plus-text__play-button--hidden');
    }

    onVideoStop() {
      if(!this.video.seeking) {
        this.video.controls = false;
        this.playButton.classList.remove('video-plus-text__play-button--hidden');
      }
    }
  }

  customElements.define('video-plus-text', VideoPlusText);
}
